// Bundle-Einstieg des modernisierten POS-Client-Teils (Mixed Mode).
// Wird in index.html als <script type="module"> NACH allen Legacy-Classic-
// Skripten geladen: Module sind deferred und laufen garantiert nach deren
// Parse-Zeit-Ausfuehrung, aber VOR $(document).ready - der Legacy-Boot
// (run() aus core/main-fnc.js, seit ESM-Welle 5c selbst im Bundle) sieht
// also alle hier publizierten Symbole.
//
// Regel: KEINE Seiteneffekte beim Laden ausser Symbol-Publikation ueber
// die legacy-bridge - mit genau einer, bewussten Ausnahme: core/main-fnc.js
// (die ESM-Huelle von FNC_main.js) laedt beim Evaluieren die vier Krypto-
// Bibliotheken per require() und registriert $(document).ready(run), exakt
// wie zuvor als Classic-Skript. Der Boot gehoert weiterhin dem Legacy-Code;
// er feuert erst bei ready, nach Evaluierung ALLER Module.
import './legacy-bridge.js';

// Marker fuers Live-Debugging ("laeuft das Bundle ueberhaupt?"):
window.POSDIAG = window.POSDIAG || {};
window.POSDIAG.bundleLoaded = true;
